import api from "../../../../../../features/auth/axiosConfig";
import { API_URLS } from "../../../../../../shared/components/Url";
import { PaymentData } from "../../types/order";
import { OrderData } from "../types/order";
import { formatDate, formatTime } from "../utils/orderUtils";

export const processPaymentRequest = async (orderid: string, order: OrderData, paymentData: PaymentData, outstandingAmount: number) => {
  const totalReceived = parseFloat(order.payments[0].ReceivedAmount) + parseFloat(paymentData.ReceivedAmount || "0");
  const remaining = parseFloat(order.Finalamount) - totalReceived - parseFloat(paymentData.discount || "0");

  const now = new Date();

  await api.patch(`${API_URLS.ORDER}/${orderid}`, {
    id: order.Customerid,
    RemainingAmount: remaining.toFixed(2),

    paymentHistory: [
      ...(order?.payments || []),
      {
        Paymentmethod: paymentData.paymentMethod,
        ReceivedAmount: paymentData.ReceivedAmount,
      },
    ],

    payments: [
      {
        Paymentmethod: paymentData.paymentMethod,
        ReceivedAmount: paymentData.ReceivedAmount,
      },
    ],

    outstanding_balance: Number(outstandingAmount),
    new_order_amount: "0",
    DeliveryDate: formatDate(now),
    DeliveryTime: formatTime(now),
    OrderStatus: "Delivered",
    Orderdate: formatDate(now),
    Ordertime: formatTime(now),
  });

  return remaining;
};
